mutation submitScaleQuestion(
  $surveyCode: String!
  $questionId: Int!
  $value: Int
  $comment: String
  $isSkipped: Boolean
  $answerTimestamp: String!
) {
  submitScaleQuestion(
    hashCode: $surveyCode
    questionId: $questionId
    rating: $value
    comment: $comment
    skippedQuestion: $isSkipped
    answerTimestamp: $answerTimestamp
  ) {
    success
    error
  }
}
